var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-progress-linear',{attrs:{"active":_vm.active,"color":_vm.color,"indeterminate":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }